(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/match-info-components/assets/javascripts/table-components/table-component.header.js') >= 0) return;  svs.modules.push('/components/sportinfo/match-info-components/assets/javascripts/table-components/table-component.header.js');
"use strict";

const {
  clx
} = svs.components.lbUtils;
const {
  TableRow
} = svs.components.sportinfo.matchInfoComponents;
const TableHeader = _ref => {
  let {
    children,
    className
  } = _ref;
  return React.createElement("thead", {
    className: clx('match_info_table-header', className)
  }, children);
};
TableHeader.Row = TableRow;
setGlobal('svs.components.sportinfo.matchInfoComponents.TableHeader', TableHeader);

 })(window);